import axios, {ResponseType} from 'axios';
import { get as getCookie } from 'tiny-cookie';
import { BACKEND_URL } from '@/plugins/variables';
import store from '@/store';
import router from '@/router';
import { resetFlowInterface } from '@/store/flowInterface';
import { resetMainInterface } from '@/store/mainInterface';
import { deleteDatabase } from '@/db';

export const enum requestMethodType {
  POST = 'POST',
  PUT = 'PUT',
  GET = 'GET',
  OPTIONS = 'OPTIONS',
  DELETE = 'DELETE',
}

export const enum loginMethodType {
  FORGOT_PASSWORD = 2,
  FORGOT_Mobile = 3,
}

axios.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  async (error) => {
    if (error.response) {
      const { data, status } = error.response;
      const message = data.message || data?.errors?.ErrorMessage[0];
     
      store.commit('showLoading', false);
  
      if (status === 401) {
        store.commit('clearAuth', false);
        await request("/api/deleteCookie", requestMethodType.POST,
            {
              "cookieName": "token",
              "isHttpOnly": "true",
              "raw": "false",
              "sameSite": "Lax",
            });
        resetFlowInterface();
        resetMainInterface();
        await deleteDatabase();
        window.location.replace('/login');
      } else if (status === 503) {
        router.push({ path: '/maintenance' });
      } else {
        if (store.getters.showGlobalError) {
          store.commit('addNotification', { title: 'Error', message: message });
        }
      }
      return Promise.reject(error.response);
    } else {
      throw error;
    }
  }
);

type optionsType = {
  headers: object,
  auth?: boolean,
  responseType?: ResponseType,
  timeout?: number,
};

const request = (
  url: string,
  method: requestMethodType,
  data: object,
  options: optionsType = { headers: {} }
) => {

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...options.headers,
  };

  return axios({
    url: `${BACKEND_URL}${url}`,
    responseType: options.responseType ?? 'json',
    method,
    data,
    headers,
    withCredentials:  true,
    timeout: options.timeout,
  });
};

export default request;
